import {
  TKwikUIInputDateSize,
  VKwikUIInputDateSize
} from "./input-date.definitions";

export const isValidKeyValue = (key: string, value: any): boolean => {
  const isBoolean = (x: boolean) => typeof x === "boolean";
  const isString = (x: string) => typeof x === "string";
  const validateCalculatedDate = (date: any): boolean => {
    const keys = Object.keys(date);
    const validKeys = ["year", "month", "day"];
    return keys.every((key) => validKeys.includes(key));
  };
  const validateDate = (date: any): boolean => {
    return (
      date.hasOwnProperty("day") &&
      date.hasOwnProperty("month") &&
      date.hasOwnProperty("year")
    );
  };

  const methods = {
    disabled: isBoolean,
    focus: isBoolean,
    formControlName: isString,
    hintContent: isString,
    icon: isString,
    id: isString,
    invalid: isBoolean,
    label: isString,
    max: validateDate,
    maxCalculatedFromToday: validateCalculatedDate,
    min: validateDate,
    minCalculatedFromToday: validateCalculatedDate,
    placeholder: isString,
    postfix: isString,
    prefix: isString,
    size: (x: TKwikUIInputDateSize) => VKwikUIInputDateSize.includes(x)
  };

  return methods[key] && methods[key](value);
};
